import {
    TextField,
    Filter,
    TextInput,
    useResourceContext,
    usePermissions,
    useTranslate,
} from "react-admin";
import { DefaultPagination } from "shared/src/components/DefaultPagination";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaEditButton } from "shared/src/components/buttons/RaEditButton";
import { RaListView } from "shared/src/components/views/RaListView";
import { CountryField } from "../components/fields/Ra/CountryField";
import { AddressField } from "../components/fields/Ra/AddressField";

const SupplierListFilter = (props) => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <TextInput
                title={translate("equip.name")}
                label="equip.name"
                source="name"
                alwaysOn
            />
        </Filter>
    );
};

export const SupplierList = (props) => {
    const translate = useTranslate();
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaListView
            {...props}
            filters={<SupplierListFilter />}
            actions={<ToolbarWithHistory create={true} export={true} />}
            pagination={<DefaultPagination />}
            perPage={50}
        >
            <DatagridWithHistory bulkActionButtons={false}>
                <TextField label="equip.name" source="name" />
                <AddressField
                    label={translate("equip.address", { addressNumber: "" })}
                />
                <TextField
                    title={translate("equip.zip")}
                    label={translate("equip.zip")}
                    source="address.zip"
                />
                <TextField
                    title={translate("equip.city")}
                    label={translate("equip.city")}
                    source="address.city"
                />
                <CountryField label={translate("equip.country")} />
                <RaEditButton title={translate("equip.edit")} />
            </DatagridWithHistory>
        </RaListView>
    );
};
